import { render, staticRenderFns } from "./DeliverySizeModal.vue?vue&type=template&id=e2746bbc&scoped=true&"
import script from "./DeliverySizeModal.vue?vue&type=script&lang=js&"
export * from "./DeliverySizeModal.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySizeModal.vue?vue&type=style&index=0&id=e2746bbc&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2746bbc",
  null
  
)

export default component.exports